import React from "react";

function Marquee() {
  const items = [
    "Thai Sports Massage",
    "Swedish Massage",
    "Hot Stone Therapy",
    "Aromatherapy",
    "Deep Tissue Massage",
    "Balinese Massage",
    "Royal H2O Signature",
    "Warm Aromatic Candle",
  ];
  const doubled = [...items, ...items];

  return (
    <div className="marquee-strip">
      <div className="marquee-inner">
        {doubled.map((item, i) => (
          <React.Fragment key={i}>
            <span className="marquee-item">{item}</span>
            <span className="marquee-item marquee-dot">✦</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default Marquee;
